import React, { useEffect, useState } from 'react';
import StyledHeadingText from '../components/Fonts/StyledHeadingText';
import CustomLoading from '../components/customLoading/CustomLoading';
import Table from '../components/tables/Table';
import Breadcrumbs from '../components/BreadCrumbs';
import Pagination from '../components/tables/pagination/Pagination';
import Button from '../components/buttons/Button';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getNotifications } from '../services/notification';
import { formatDateTime } from '../utils/FormatDateTime';
import Dropdown from '../components/inputFields/DropDown';
import { BiRefresh } from 'react-icons/bi';

function Notifications() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [filteredType, setFilteredType] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "S. No.", key: "i" },
        { label: "Send On", key: "created_at" },
        { label: "Title", key: "title" },
        // { label: "Message", key: "message" },
        { label: "Image", key: "image" },
        // { label: "Redirection", key: "to_redirect" },
        { label: "Template", key: "template" },
        { label: "Logs", key: "logs" },
    ];

    const pageSize = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (filters) => {
        setLoading(true);
        try {
            let res = await getNotifications({
                filter: filters || "",
            });
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleTypeChange = (value) => {
        setFilteredType(value);
        fetchData(`?category=${value}`);
    };

    const resetFilters = () => {
        setFilteredType("");
        fetchData("");
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Notifications' },
        ]} />
        <div className="flex flex-row justify-between item-center">
            <div className="py-2 flex flex-row gap-2 items-center">
                <StyledHeadingText text={"Notifications"} />
                <div className="min-w-48 flex flex-row gap-2">
                    <Dropdown
                        placeholder="Select Banner Type"
                        options={[
                            {
                                label: "General",
                                value: "general",
                            },
                            {
                                label: "Bazaar (Mobile)",
                                value: "bazaar_mobile",
                            },
                            {
                                label: "Devices",
                                value: "devices",
                            },
                            {
                                label: "Expense",
                                value: "expense",
                            },
                            {
                                label: "Satellite",
                                value: "satellite",
                            },
                            {
                                label: "Community (Forum & Post)",
                                value: "community",
                            },
                            {
                                label: "Farm & Commodity",
                                value: "farm_commodity",
                            },
                            {
                                label: "Mandi Rate",
                                value: "mandi_rate",
                            },
                            {
                                label: "Diseases & Precautions",
                                value: "diseases_precautions",
                            },
                            {
                                label: "NPK Calculator",
                                value: "npk_calculator",
                            },
                            {
                                label: "Dukaan App",
                                value: "dukaan_app",
                            },
                        ]}
                        onChange={handleTypeChange}
                        value={filteredType}
                        needSearch={false}
                    />
                    {(filteredType.length !== 0) && (
                        <BiRefresh
                            size={32}
                            className="cursor-pointer text-primary"
                            onClick={resetFilters}
                        />
                    )}
                </div>
            </div>
            <Link to="/notification/notification-campaing" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Show Campaigns
                </Button>
            </Link>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                i: <p>{index + 1}</p>,
                                title: <span className='flex flex-row gap-1 items-center'><p className="max-w-36 truncate cursor-help" title={item.title}>{item.title}</p></span>,
                                message: <span className='flex flex-row gap-1 items-center'><p className="max-w-40 truncate cursor-help" title={item.message}>{item.message}</p></span>,
                                image: <img src={item.image} alt={item.image} className='w-10 h-10 aspect-square rounded-sm border object-contain' />,
                                to_redirect: <span className='flex flex-row gap-1 items-center'><p className="max-w-32 truncate cursor-help" title={item.to_redirect}>{item.to_redirect}</p></span>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                template: <span className='flex flex-row gap-1 items-center'><p className="max-w-32 truncate cursor-help" title={item.template}>{item.template}</p></span>,
                                logs: <span className='flex flex-row gap-1 items-center'><p className="max-w-4xl truncate cursor-help" title={item.logs}>{item.logs}</p></span>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                />
                : <></>
        }
    </>);
}

export default Notifications;